export default __webpack_public_path__ + "static/animation_drag_mouse-aa9a3e97b08d4f59eec7c193531f2d21.webm";